import { makeStyles } from '@material-ui/core/styles'

export const emergencyInfoStyles = makeStyles((theme) => ({
  centerPage: {
    padding: '65px 0px 0px 55px',

    [theme.breakpoints.down('sm')]: {
      padding: '55px 0px 0px 0px',
    },
  },
  container: {
    margin: 'auto',
    width: '60dvw',
    maxWidth: 600,
    [theme.breakpoints.down('sm')]: {
      width: '80dvw',
      maxWidth: '80dvw',
    },
  },
  sectionTitle: {
    margin: theme.spacing(1, 0),
    width: '100%',
  },
  backButton: {
    padding: theme.spacing(1, 2, 1, 0),
    background: theme.palette.backgroundColor.main,
  },
  backButtonText: {
    fontWeight: 600,
    textAlign: 'left',
  },
  fullWidth: {
    width: '100%',
  },
  singleCard: {
    margin: theme.spacing(0, 0, 2, 0),
    width: '100%',
    borderRadius: '8px',
    backgroundColor: theme.palette.backgroundColor.secondary,
  },
  cardHeader: {
    color: theme.color.white,
    backgroundColor: theme.color.rutgersRed,
    width: '100%',
    display: 'grid',
    justifyItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  mainMenuCardContent: {
    padding: theme.spacing(0.5),
  },
  cardContent: {
    padding: theme.spacing(1),
  },
  bigBlueButtonGrid: {
    display: 'flex',
    gridAutoRows: '1fr',
    margin: theme.spacing(0.5),
    width: 'calc(50% - 8px)',
  },
  bigBlueButton: {
    flex: 1,
    display: 'block',
    backgroundColor: theme.color.darkBlue,
    padding: theme.spacing(2.5),
    width: '100%',
    height: '100%',
    borderRadius: theme.spacing(1),
  },
  blueButtonText: {
    marginTop: theme.spacing(2),
    color: theme.color.white,
  },
  iconGrid: {
    padding: theme.spacing(3, 0),
  },
  divider: {
    margin: theme.spacing(1, 0),
    backgroundColor: theme.palette.components.icon,
  },
  subheader: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  bodyTextSpacing: {
    marginBottom: theme.spacing(1),
  },
  cardGridContainer: {
    padding: 20,
  },
  hospitalButton: {
    display: 'grid',
    flex: 1,
    width: '100%',
    marginTop: theme.spacing(1),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.color.darkBlue,
    color: theme.color.white,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: theme.color.darkBlue,
    },
  },
  phoneBox: {
    backgroundColor: theme.color.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 4),
    marginTop: theme.spacing(1),
    width: 'fit-content',
    color: theme.color.black,
    justifySelf: 'center',
  },
  phoneWithoutLink: {
    color: theme.color.linkText,
    textDecoration: 'none',
  },
  moreInfoButon: {
    borderRadius: 5,
    width: '100%',
    height: 50,
    marginBottom: 15,
  },
  phoneLink: {
    color: theme.palette.components.linkText,
    textDecoration: 'underline',
  },
}))

export default emergencyInfoStyles
